import { Avatar, SecondCustomInput } from "@/components";
import { BackAppBar } from "@/components/ui";
import { useDebounce } from "@/hooks/useDebounce";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import SearchIcon from "@mui/icons-material/Search";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import { createFileRoute } from "@tanstack/react-router";
import { zodSearchValidator } from "@tanstack/router-zod-adapter";
import { z } from "zod";

const SSO_PROVIDERS = [
	{
		id: 0,
		name: "MHNexus",
		img: "/images/mhnexus.png",
	},
];

export const Route = createFileRoute("/sso/select-provider")({
	validateSearch: zodSearchValidator(
		z.object({
			q: z.string().optional(),
		}),
	),
	component: RouteComponent,
});

function RouteComponent() {
	const navigate = Route.useNavigate();
	const searchQ = Route.useSearch({
		select: (search) => search.q ?? "",
	});
	const debounceSearch = useDebounce(searchQ, 300);
	const providers = SSO_PROVIDERS.filter((provider) =>
		provider.name.toLowerCase().includes(debounceSearch.toLowerCase()),
	);
	return (
		<>
			<BackAppBar />
			<div className="container py-4 flex-1 flex flex-col items-center justify-normal gap-8">
				<SecondCustomInput
					type="search"
					name="search"
					placeholder="Search for SSO"
					startIcon={<SearchIcon />}
					value={searchQ}
					onChange={(e) =>
						navigate({
							search: {
								q: e.target.value || undefined,
							},
							replace: true,
						})
					}
				/>
				<List className="!w-full">
					{providers.map((provider) => (
						<ListItem
							key={provider.id}
							secondaryAction={<CheckCircleIcon color="primary" />}
							disablePadding
						>
							<ListItemButton>
								<ListItemAvatar>
									<Avatar
										alt={provider.name}
										src={provider.img}
										className="[&_img]:object-center [&_img]:object-contain"
									/>
								</ListItemAvatar>
								<ListItemText primary={provider.name} />
							</ListItemButton>
						</ListItem>
					))}
				</List>
			</div>
		</>
	);
}
